<h2 mat-dialog-title>SMA – {{ data.licenceName }}</h2>

<mat-dialog-content>
  <div *ngIf="loading" class="loading-wrapper">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <ng-container *ngIf="!loading">
    <div *ngIf="smas.length === 0" class="no-data">
      {{ "Keine SMA-Einträge vorhanden" | translate }}
    </div>

    <div *ngIf="smas.length > 0" class="table-wrapper">
      <table class="sma-view-table" [class.with-actions]="isAdminOrOperator">
        <thead>
          <tr>
            <th>{{ "Produkt" | translate }}</th>
            <th>{{ "Auftragsbestätigung" | translate }}</th>
            <th>{{ "Von" | translate }}</th>
            <th>{{ "Bis" | translate }}</th>
            <th *ngIf="isAdminOrOperator">{{ "Aktion" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sma of smas">
            <td>{{ sma.product_id || '–' }}</td>
            <td>{{ sma.document_number || '–' }}</td>
            <td>{{ sma.start_date | date:'dd.MM.yyyy' }}</td>
            <td>{{ sma.end_date ? (sma.end_date | date:'dd.MM.yyyy') : 'offen' }}</td>
            <td *ngIf="isAdminOrOperator">
              <button mat-button color="warn" (click)="unassignSma(sma)" [title]="'Abkoppeln' | translate">
                <mat-icon>link_off</mat-icon>
                {{ "Abkoppeln" | translate }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ "Close" | translate }}</button>
</mat-dialog-actions>
